import { useGetReadTokenQuery } from '@dap/sanity/data-access';
import { PropsWithChildren } from 'react';
import { ErrorPage } from '@dap/common/pages';
import { useTranslation } from 'react-i18next';
import { dapSanityClient } from '@dap/sanity/data-access';
// import { config } from '@dap/app/config';

export const SanityReadTokenEnabler = (props: PropsWithChildren) => {
  const { t } = useTranslation('common');

  // Fetch the read token from the API
  const tokenState = useGetReadTokenQuery();
  const { status, data: { token } = { token: undefined } } = tokenState;

  switch (true) {
    case status === 'fulfilled' && typeof token === 'string': {
      // A read token is defined on the server, update the Sanity client with the returned token
      dapSanityClient.config({ token });
      return props.children;
    }

    case status === 'fulfilled' && token === false:
      // A read token is not defined on the server, return the children as is and expect the dataset to be public. If the dataset is private, queries for content will fail.
      return props.children;

    case status === 'rejected':
      // If the request was rejected, show an error page
      return <ErrorPage message={t('sanity.error.missingReadToken')} />;

    default:
      return null;
  }
};
